module.exports = "query GetSponsors($search: String!) {\n  sponsors(search: $search) {\n    ...SponsorFragment\n  }\n}\n"